import type { FloorPlanName } from '../../types';

export interface FloorPlanDetails {
  floors: number;
  bedrooms: number;
  bathrooms: number;
  sqft: number;
}

export const FLOOR_PLANS_DETAILS: Record<FloorPlanName, FloorPlanDetails> = {
  Birch: { floors: 2, bedrooms: 5, bathrooms: 3, sqft: 2723 },
  'Country Living': {
    floors: 1,
    bedrooms: 4,
    bathrooms: 3.5,
    sqft: 2230,
  },
  Elderberry: { floors: 2, bedrooms: 5, bathrooms: 5.5, sqft: 3870 },
  Harmony: { floors: 1, bedrooms: 3, bathrooms: 2, sqft: 1600 },
  Hickory: { floors: 1, bedrooms: 3, bathrooms: 2.5, sqft: 2990 },
  Hyacinth: { floors: 1, bedrooms: 3, bathrooms: 2, sqft: 1205 },
  Kingston: { floors: 1, bedrooms: 3, bathrooms: 2, sqft: 2030 },
  Redbud: { floors: 1, bedrooms: 3, bathrooms: 2, sqft: 2075 },
  Sage: { floors: 2, bedrooms: 4, bathrooms: 2, sqft: 1450 },
  Serenity: { floors: 2, bedrooms: 3, bathrooms: 2, sqft: 1875 },
  Willow: { floors: 1, bedrooms: 3, bathrooms: 3.5, sqft: 2811 },
  Mulberry: { floors: 2, bedrooms: 3, bathrooms: 3, sqft: 2309 },
  'River Ranch': { floors: 1, bedrooms: 3, bathrooms: 2, sqft: 2000 },
};
